'use strict'
module.exports = function (node) {
  if (this.options.raw) {
    return node.value
  }
  return this.options.factory + '(' + node.value + ')'
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-codegen/lib/node/ConstantNode.js
// module id = 6xkx
// module chunks = 0